import { formatDate, handleResponse } from './general';
import { v4 as uuidv4 } from 'uuid';
/**
 * function that returns the object based on the values that are been sent
 * for page tracking.
 *
 * @param {Object} location :: This object contains required page url and page domain details.
 * @param {Object} target :: This object contains the target page url.
 * @param {String} name :: This gives the merchant name.
 * @param {String} buttonPosition :: This is the position of the button.
 *
 * @return {Object} :: date returned which is built on values which are sent.
 */

export function buildDataForPushEventStreamData(location, target, name, buttonPosition, ip, guid) {
  return {
    buttonposition: "".concat(buttonPosition, "%"),
    categoryid: guid,
    clientdate: formatDate(),
    device: null,
    esubtype: 'buybttn',
    etype: 'click',
    gasessionid: 'ga-1101140981.1507593958',
    merchant: name,
    os: null,
    outboundurl: target ? target.href : '',
    pagedomain: location.host,
    pageurl: location.href,
    price: null,
    transactionId: makeTransactionId(),
    ua: navigator.userAgent,
    userip: ip
  };
}
/**
 * function that calculates the distance of the element from the top of the page
 * measured in pixels
 *
 * @param given element
 *
 * @return {Number} yPos :: number of pixels from top of the page
 */

export function getDistanceFromTop(element) {
  var yPos = 0;

  while (element) {
    yPos += element.offsetTop;
    element = element.offsetParent;
  }

  return yPos;
}
/**
 * Generates a unique transaction ID for use by BI per this document
 * https://purch1.atlassian.net/wiki/spaces/BI/pages/113311807/Transaction+ID+Format
 *
 * @return {String} Unique transaction ID
 */

export function makeTransactionId() {
  return "BDCM".concat(uuidv4().replace(/-/g, ''));
}
/**
 * function that makes an api call to save page tracking that is created.
 *
 * @param {Object} obj :: which contains all the data regarding page tracking
 *
 */

export function pushEventStreamData(obj) {
  var endPoint = 'https://rh8u5tet1i.execute-api.us-east-1.amazonaws.com/dev/click';
  fetch(endPoint, {
    headers: {
      'Access-Control-Allow-Origin': '*',
      Accept: 'text/plain',
      'Content-Type': 'text/plain'
    },
    mode: 'no-cors',
    body: JSON.stringify(obj),
    credentials: 'include',
    method: 'POST'
  }).then(handleResponse)["catch"](function (error) {
    return error;
  });
}
/**
 * Checks to see if there is a dataLayer defined on the window and if so pushes the passed object onto it
 *
 * @param  {Object} obj :: data to be pushed onto dataLayer array
 */

export function pushGtmData(obj) {
  window.dataLayer && window.dataLayer.push(obj);
}
/**
 * function that makes an api call to get the user ip address.
 *
 * @param {Object} :: it contains all the user related data i.e country,ip address,etc..
 *
 */

export function getIp() {
  return fetch('https://geoip.nekudo.com/api/<ip_address>').then(handleResponse)["catch"](function () {
    return '99.99.99.99';
  });
}